import { useContext, useEffect } from 'react';
import { Channel } from '../features/api/apiSlice';
import { ChannelStatus } from '../components/Stream/Channels/Channels.interface';
import { ChannelStatusContext, getInitialStatuses } from '../components/Stream/Channels/ChannelStatusContext';

export const useChannelStatuses = (channels?: Channel[]) => {
  const { channelStatuses, setChannelStatuses } = useContext(ChannelStatusContext);

  useEffect(() => {
    if (!channels) return;

    const newStatuses = getInitialStatuses(channels);

    setChannelStatuses((prev: ChannelStatus) => {
      const updated = { ...prev };

      channels.forEach(channel => {
        if (!updated[channel.id]) {
          updated[channel.id] = newStatuses[channel.id];
        }
      });

      return updated;
    });
  }, [channels, setChannelStatuses]);

  return { channelStatuses };
};